import { useTranslation } from "react-i18next";
import { Link } from "react-router";

/**
 * The page a guest has reached and cannot be given.
 *
 * Five sections leave the row of sections for a guest at `9.2`, and a link
 * that is not drawn can still be typed, bookmarked before somebody's access
 * changed, or followed out of a phone's history. So the screens behind them
 * say what they are in a sentence and point back to the wines, which is where
 * a guest was going.
 *
 * A sentence rather than a redirect: being moved somewhere without being told
 * why reads as the application having lost the page, and the honest answer —
 * this part of the cellar is the owner's — costs one line. It is also not an
 * error, so it is quiet text and not `role="alert"`; nothing has gone wrong.
 */
export function OwnersOnly({ cellarId }: { cellarId: string }) {
  const { t } = useTranslation();

  return (
    <p className="text-muted mt-6 max-w-prose text-sm">
      {t("guest.ownersOnly")}{" "}
      <Link
        to={`/kallare/${cellarId}`}
        className="text-accent underline-offset-4 hover:underline"
      >
        {t("guest.backToWines")}
      </Link>
    </p>
  );
}
